/* エキップ サイト共通 v1 : 商品ページの整理・追従カートバー・送料無料バー */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };

  /* 1) 商品名：SEO用の長い名称を「商品名」と「補足」に分ける */
  var h1 = $('.product__title h1');
  if (h1 && h1.textContent.indexOf(' | ') > 0) {
    var parts = h1.textContent.split(' | ');
    h1.textContent = parts[0];
    var tag = document.createElement('p');
    tag.className = 'eq-ptag';
    tag.textContent = parts.slice(1).join(' | ');
    h1.insertAdjacentElement('afterend', tag);
  }

  /* 2) サイズ切替・安心情報を購入ボタン周りへ移動（JSが動かなくてもセクション内に残る） */
  var sizes = $('#eq-sizes-src'), bb = $('#eq-buybox-src');
  var form = $('product-form');
  var qty = $('.product__info-container .product-form__quantity');
  if (sizes && qty) qty.parentElement.insertBefore(sizes, qty);
  if (bb && form) {
    var host = form.parentElement;
    while (host && host.parentElement && host.parentElement.className.indexOf('product__info-container') < 0) host = host.parentElement;
    if (host && host.parentElement) host.insertAdjacentElement('afterend', bb);
  }

  /* 3) 追従カートバー（スマホ） */
  var submit = $('.product-form__submit');
  if (submit) {
    var priceEl = $('.price__container .price-item--regular') || $('.price-item');
    var bar = document.createElement('div');
    bar.className = 'eq-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="eq-sticky__i"><b></b><span></span></div><button type="button" tabindex="-1">カートに追加</button>';
    $('b', bar).textContent = (h1 ? h1.textContent : document.title).replace(/\s+/g, ' ');
    $('span', bar).textContent = priceEl ? priceEl.textContent.replace(/\s*JPY/, '').trim() : '';
    $('button', bar).addEventListener('click', function () { submit.click(); });
    document.body.appendChild(bar);
    var onScroll = function () {
      bar.classList.toggle('is-on', submit.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 4) カートドロワー・カートページの送料無料バー（16,500円） */
  var LIMIT = 16500;
  function fmt(n) { return '¥' + n.toLocaleString('ja-JP'); }
  function render(total) {
    var targets = document.querySelectorAll('.cart-notification__links, .cart-drawer__footer, .cart__footer, #main-cart-footer .cart__blocks');
    targets.forEach(function (t) {
      var el = t.querySelector('.eq-ship');
      if (!el) { el = document.createElement('div'); el.className = 'eq-ship'; t.insertBefore(el, t.firstChild); }
      var ok = total >= LIMIT;
      el.classList.toggle('is-ok', ok);
      el.style.setProperty('--p', Math.min(100, Math.round(total / LIMIT * 100)) + '%');
      el.innerHTML = (ok ? '送料無料の対象です' : 'あと <b>' + fmt(LIMIT - total) + '</b> で送料無料') + '<div class="trk"><i></i></div>';
    });
  }
  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c.item_count > 0) render(Math.round(c.total_price / 100)); })
      .catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', refresh);
  /* カート操作（追加・変更）の通信を検知して再計算 */
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var p = _fetch.apply(this, arguments);
      try {
        var a = arguments[0];
        var u = String(a && a.url ? a.url : a);
        if (/\/cart\/(add|change|update)/.test(u)) p.then(function () { setTimeout(refresh, 350); });
      } catch (err) {}
      return p;
    };
  }
  new MutationObserver(function () {
    if (($('.cart-drawer__footer') && !$('.cart-drawer__footer .eq-ship')) || ($('.cart-notification__links') && !$('.cart-notification__links .eq-ship'))) refresh();
  })
    .observe(document.body, { childList: true, subtree: true });
})();
